import { useCallback } from 'react';
import { useUrlState } from './useUrlState';

interface UseUrlPaginationResult {
  page: number;
  setPage: (page: number) => void;
  resetPage: () => void;
}

export const useUrlPagination = (defaultPage = 1): UseUrlPaginationResult => {
  const [urlState, setUrlState] = useUrlState({ page: defaultPage });

  const setPage = useCallback(
    (page: number) => {
      setUrlState(prev => ({ ...prev, page }));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    [setUrlState],
  );

  const resetPage = useCallback(() => {
    setUrlState(prev => ({ ...prev, page: defaultPage }));
  }, [setUrlState, defaultPage]);

  return {
    page: urlState.page,
    setPage,
    resetPage,
  };
};
